<template>
  <div class="box-aboutOurCards">
    <img v-complete:src="mydata.articleInfo.image" />
    <p>
      {{ mydata.articleInfo.intro }}
    </p>
    <el-button type="primary" round @click="submitButton(mydata.articleInfo.id)"
      >了解详情</el-button
    >
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
// 引入接口
import { getConfig } from "@/api/list/index.js";
// 引入接口
import { articleInfo } from "@/api/home/index.js";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  teacherArticleObj: {},
  articleInfo: {}, // 文章详情
  articleId: null, // 文章id值
});

const props = defineProps({
  path: {
    type: String,
    default: "",
  },
  // info: {
  //   type: Object,
  //   default: () => {
  //     return {};
  //   },
  // },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}

//配置列表的teacher_article的value
function getConfigFn() {
  getConfig().then((res) => {
    mydata.teacherArticleObj = res.data.teacher_article;
    // console.log(mydata.teacherArticleObj,"合作平台")
    init();
  });
}
getConfigFn();

// 文章详情
function init() {
  // 获取到传递过来的参数
  // mydata.articleId = route.query.id;
  //  mydata.articleId = mydata.teacherArticleObj.value
  // 调用接口获取文章详情
  articleInfo({ id: mydata.teacherArticleObj.value }).then((res) => {
    // console.log("文章接口", res.data);
    mydata.articleInfo = res.data;
  });
}
</script>


<style scoped lang="scss">
.box-aboutOurCards {
  // border:1px solid blue;
  // position: relative;
  // height: 343px;
  // box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
  img {
    max-width: 100%;
    // max-height: 333px;
    // height:333px;
    margin-bottom: 20px;
    //   border:1px solid red;
    display: block;
    margin: 0 auto;
  }
  p {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #666666;

    // display: -webkit-box;
    // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    // text-overflow: ellipsis; //文本溢出 用省略号显示
    // -webkit-line-clamp: 4; //几行
    // overflow: hidden;
  }
  :deep(.el-button) {
    margin: 0 auto;
    display: block;
    width: 50%; /* 或者具体宽度 */
    margin-top: 20px;
  }
  :deep(.el-button.el-button--primary.is-round) {
    border: 1px solid #009de0;
    width: 206px;
    height: 42px;
    // position: absolute;
    // right: 0px;
    // bottom: 0px;
  }
  :deep(.el-button.el-button--primary.is-round > span) {
    color: #ffffff !important;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>